<template>
  <div>
    <pdf-viewer-ui :src="url"/>
  </div>
</template>

<script>
  import PdfViewerUi from "@/components/pdfViewer/PdfViewerUi";

  export default {
    name: "PdfReader",
    components: {
      PdfViewerUi,
    },
    data() {
      return {
        url: window.config.basicServerHttpUrl + "pans/downLoadFile?id=" + this.$route.query.id,
      };
    },
  };
</script>
<style lang="scss">
</style>